import { SARABAExecutor } from "./SARABAExecutor";
import { SARABSExecutor } from "./SARABSExecutor";
import { SARAVAExecutor } from "./SARAVAExecutor";
import { SARAVSExecutor } from "./SARAVSExecutor";
import { Sb24AExecutor } from "./Sb24AExecutor";
import { Sb24Executor } from "./Sb24Executor";

type execKey = "57243" | "57674" | "57675" | "57245" | "57242" | "57671" | "57672";

const executors = {
  "57243": Sb24Executor,
  "57674": SARABAExecutor,
  "57675": SARABSExecutor,
  "57245": Sb24AExecutor,
  "57242": Sb24Executor,
  "57671": SARAVSExecutor,
  "57672": SARAVAExecutor
};

export const createExecutor = (name: execKey) => {
  return new executors[name];
};
